import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditCustomer from './AddEditCustomerWidget';
import { useDispatch} from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface AddEditUserPageProps extends IAppPropsWithRoute {

};

function AddEditUserPage(props: AddEditUserPageProps): JSX.Element {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
    const customerId = props.match.params.customerId;

    const renderChild = () => {
        return <AddEditCustomer customerId={customerId} />;
    }

    return (
        <React.Fragment>
            {renderChild()}
        </React.Fragment>
    );
}

export default React.memo(withRouter(AddEditUserPage));